import { Route, BrowserRouter as Router, Routes } from "react-router";
import AppLayout from "./layout/AppLayout";
import AuthLayout from "./layout/AuthLayout";
import SignIn from "./pages/AuthPages/SignIn";
import SignUp from "./pages/AuthPages/SignUp";
import Blank from "./pages/Blank";
import Calendar from "./pages/Calendar";
import Ecommerce from "./pages/Dashboard/ECommerce";
import FormElements from "./pages/Forms/FormElements";
import NotFound from "./pages/OtherPage/NotFound";
import BasicTables from "./pages/Tables/BasicTables";
import Alerts from "./pages/UiElements/Alerts";
import Avatars from "./pages/UiElements/Avatars";
import Badges from "./pages/UiElements/Badges";
import Buttons from "./pages/UiElements/Buttons";
import Images from "./pages/UiElements/Images";
import Videos from "./pages/UiElements/Videos";
import UserProfiles from "./pages/UserProfiles";
// import AddCarrier from "./pages/Master/AddCarrier";
// import Trailer from "./pages/Master/AddTrailer";
import TrackVehicle from "./pages/Tracking/TrackVehicle";
import { filterMneus } from "./layout/AppSidebar";
import Counter from "./pages/redux-test/Counter";
import AddDrivers from "./pages/Master/AddDrivers";
import AssignLoad from "./pages/Master/AssignLoad";
import LoadOrders from "./pages/Master/LoadOrders";
import Emp from "./pages/Master/emp";
import AddFrom from "./pages/Form/AddForm";
import AddFromSections from "./pages/Form/AddFormSections";
import AddFromColumns from "./pages/Form/AddFormColumns";
import Users from "./pages/Admin/users";
import ResetPassword from "./pages/AuthPages/ResetPassword";
import ForgotPassword from "./pages/AuthPages/ForgotPassword";
import DriverOrder from "./pages/Driver/Order";
import CarrierUser from "./pages/Admin/CarrierUser";
import Customer from "./pages/crm/customer";
import Shipper from "./pages/crm/shipper";
import Chat from "./pages/ChatBox/Chat";
import LoadOrdersDetails from "./pages/Master/LoadOrders_details";
import Home from "./pages/Website/Home";
import DriverReports from "./pages/Reports/DriverReports";
import Truckeports from "./pages/Reports/TruckReports";
import AccountDrivers from "./pages/Accounting/AccountDrivers";
import Expenses from "./pages/Driver/expenses";
import CustomerBroker from "./pages/Driver/customerBroker";
import Payroll from "./pages/Driver/payroll";
import Invoice from "./pages/Driver/invoice";
import IftaFuel from "./pages/Driver/ifta_fuel";
import { Carriers } from "./pages/Carrier/Carriers";
import CarrierForm from "./pages/Carrier/CarriersForm";
import { Trailer } from "./pages/Trailer/Trailer";
import TrailerForm from "./pages/Trailer/TrailerForm";
import { Vehicle } from "./pages/Vehicle/Vehicle";
import VehicleForm from "./pages/Vehicle/VehicleForm";
import { Driver } from "./pages/Driver/Driver";
import DriverForm from "./pages/Driver/DriverForm";
import { Load } from "./pages/load/load";
import LoadForm from "./pages/load/loadform";
import ContactUs from "./pages/Website/ContactUs";
import AboutUs from "./pages/Website/AboutUs";
import ScrollToTop from "./utils/scrollToTop";
import { Employee } from "./pages/Employee/Employee";
import EmployeeForm from "./pages/Employee/EmployeeForm";
import ShipperTrailer from "./pages/Dashboard/Shipper";

//testing
export default function App() {
  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Dashboard Layout */}
          <Route element={<AppLayout />}>
            <Route
              index
              path="/dashboard/shipperLocation"
              element={<ShipperTrailer />}
            />
            <Route index path="/dashboard" element={<Ecommerce />} />
            {/* Others Page */}
            <Route path="/profile" element={<UserProfiles />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/blank" element={<Blank />} />

            {/* Forms */}
            <Route path="/form-elements" element={<FormElements />} />

            {/* Tables */}
            <Route path="/basic-tables" element={<BasicTables />} />

            {/* Ui Elements */}
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/avatars" element={<Avatars />} />
            <Route path="/badges" element={<Badges />} />
            <Route path="/buttons" element={<Buttons />} />
            <Route path="/images" element={<Images />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/redux-test" element={<Counter />} />

            {/* {filterMneus.map((items, _) => {

              return (
                <Route key={_}>
                  {items?.subItems?.map((path, index) => {
                    return (
                      <Route
                        key={index}
                        path={path?.path}
                        element={<AddCarrier />}
                      />
                    );
                  })}
                </Route>
              );
            })} */}
            <Route path="/users/users" element={<Users />} />
            {/* 
             <Route path="/fleet/carrier" element={<AddCarrier />} /> 
             <Route path="/fleet/trailer" element={<Trailer />} />
             <Route path="/fleet/drivers" element={<AddDrivers />} />
              <Route path="/dispatch/load" element={<Load />} />

            
            */}
            {/* dynamic routes */}
            <Route path="/fleet/carrier" element={<Carriers />} />
            <Route path="/fleet/carrier/form" element={<CarrierForm />} />
            <Route path="/fleet/trailer" element={<Trailer />} />
            <Route path="/fleet/trailer/form" element={<TrailerForm />} />
            <Route path="/fleet/vehicle" element={<Vehicle />} />
            <Route path="/fleet/vehicle/form" element={<VehicleForm />} />
            <Route path="/fleet/drivers" element={<Driver />} />
            <Route path="/fleet/drivers/form" element={<DriverForm />} />
            <Route path="/dispatch/load" element={<Load />} />
            <Route path="/dispatch/load/form" element={<LoadForm />} />

            <Route path="/crm/employee" element={<Employee />} />
            <Route path="/crm/employee/form" element={<EmployeeForm />} />

            {/* <Route path="/fleet/assignload" element={<AssignLoad />} /> */}
            <Route path="/fleet/bookings" element={<LoadOrders />} />
            <Route
              path="/fleet/bookings/details/:id"
              element={<LoadOrdersDetails />}
            />

            <Route path="/tracking/trackvehicle" element={<TrackVehicle />} />
            <Route path="/crm/customer" element={<Customer />} />
            <Route path="/crm/shipper" element={<Shipper />} />

            <Route path="/accounting/drivers" element={<AccountDrivers />} />

            <Route path="/reports/driver_reports" element={<DriverReports />} />
            <Route path="/reports/truck_reports" element={<Truckeports />} />

            <Route path="/form/addform" element={<AddFrom />} />
            <Route path="/form/addsection" element={<AddFromSections />} />
            <Route path="/form/addcoulumn" element={<AddFromColumns />} />
            <Route path="/orders/new_orders" element={<DriverOrder />} />
            <Route
              path="/orders/new_orders/details/:id"
              element={<LoadOrdersDetails />}
            />

            <Route path="/fleet/drivers/expenses" element={<Expenses />} />
            <Route
              path="/fleet/drivers/customerBroker"
              element={<CustomerBroker />}
            />
            <Route path="/fleet/drivers/payroll" element={<Payroll />} />
            <Route path="/fleet/drivers/iftaFuel" element={<IftaFuel />} />
            <Route path="/fleet/drivers/invoice" element={<Invoice />} />

            <Route path="/users/permissions" element={<Emp />} />
            <Route path="/carrier_user" element={<CarrierUser />} />
            <Route path="/chat" element={<Chat />} />
          </Route>

          {/* Auth Layout */}
          <Route element={<AuthLayout />}>
            <Route path="/tr" element={<TrackVehicle />} />
            <Route path="/" element={<Home />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/signin" element={<SignIn />} />

            <Route path="/generatepassword" element={<ForgotPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/reset-password" element={<ResetPassword />} />

            {/* <Route path="/signup" element={<SignUp />} /> */}
          </Route>

          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
}
